import type { NextPage } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import BrandFilter from '../../components/cars/brand-filter';
import CarCard from '../../components/cars/car-card';
import { getStaticPropsNicho } from 'ui';
import { db } from 'data';
import { Brand, Car, Cooches } from '../../data/schema';
import { readItems } from '@directus/sdk';

type Props = {
	cars: Car[];
	brands: Brand[];
};

const Dashboard: NextPage<Props> = ({ cars, brands }: Props) => {
	const [filters, setFilters] = useState<{ brands: string[] }>({ brands: [] });
	const [displayCars, setDisplayCars] = useState(cars);

	const carsComponents = displayCars
		.filter((lead: Car) => {
			if (filters.brands.length > 0) {
				if (!lead.brand) {
					return false;
				}

				const brandCode = lead.brand as string;

				if (!filters.brands.includes(brandCode)) {
					return false;
				}
			}

			return true;
		})
		.map((car: Car) => {
			let image = `/images/under-construction.png`;
			const brand = brands.find((brand) => brand.id === car.brand);

			if (car.raw?.image) {
				image = car.raw.image;
			}

			return <CarCard key={car.id} car={car} brand={brand} />;
		});

	return (
		<main className="dark:bg-gray-800 rounded-2xl mb-16 w-full">
			<div className="flex items-start justify-between w-full">
				<div className="h-screen hidden lg:block m-4 shadow-lg w-80">
					<div className="bg-white rounded-2xl dark:bg-gray-700">
						<div className="flex items-center justify-center pt-6">
							<Link href="/" className="dark:hidden">
								<Image
									src="/images/logos/logo.png"
									className="h-10 w-8 object-contain"
									height={35}
									width={100}
									alt="cooches"
								/>
							</Link>
							<Link href="/" className="hidden dark:block">
								<Image
									src="/images/logos/logo-white.png"
									className="h-10 w-8 object-contain"
									height={35}
									width={100}
									alt="cooches"
								/>
							</Link>
						</div>
						<div>
							<p className="text-gray-300 ml-2 w-full border-b-2 pb-2 border-gray-100 mb-4 text-md font-normal">
								Filtros
							</p>
							<div>
								<BrandFilter
									brands={brands}
									onFilter={(brands: string[]) => {
										setFilters({ ...filters, brands });
									}}
								/>
								{/*<div className="m-3 relative">
									<button
										type="button"
										className="relative w-fuyarn ll bg-white rounded-md shadow-lg pl-3 pr-10 py-3 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
										<span className="flex items-center">
											<img
												src="/images/person/2.jpeg"
												alt="person"
												className="flex-shrink-0 h-6 w-6 rounded-full"
											/>
											<span className="ml-3 block truncate">John Jackson</span>
										</span>
										<span className="ml-3 absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
											<svg
												className="h-5 w-5 text-gray-400"
												xmlns="http://www.w3.org/2000/svg"
												viewBox="0 0 20 20"
												fill="currentColor"
												aria-hidden="true">
												<path
													fill-rule="evenodd"
													d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
													clip-rule="evenodd"></path>
											</svg>
										</span>
									</button>
									<div className="absolute mt-1 w-full z-10 rounded-md bg-white shadow-lg">
										<ul
											tabindex="-1"
											role="listbox"
											aria-labelledby="listbox-label"
											aria-activedescendant="listbox-item-3"
											className="max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
											<li
												id="listbox-item-0"
												role="option"
												className="text-gray-900 cursor-default hover:bg-indigo-500 hover:text-white select-none relative py-2 pl-3 pr-9">
												<div className="flex items-center">
													<img
														src="/images/person/1.jpg"
														alt="person"
														className="flex-shrink-0 h-6 w-6 rounded-full"
													/>
													<span className="ml-3 block font-normal truncate">Mick Poulaz</span>
												</div>
												<span className="absolute inset-y-0 right-0 flex items-center pr-4">
													<svg
														className="h-5 w-5"
														xmlns="http://www.w3.org/2000/svg"
														viewBox="0 0 20 20"
														fill="currentColor"
														aria-hidden="true">
														<path
															fill-rule="evenodd"
															d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
															clip-rule="evenodd"></path>
													</svg>
												</span>
											</li>
											<li
												id="listbox-item-1"
												role="option"
												className="text-gray-900 cursor-default select-none hover:bg-indigo-500 hover:text-white relative py-2 pl-3 pr-9">
												<div className="flex items-center">
													<img
														src="/images/person/1.jpg"
														alt="person"
														className="flex-shrink-0 h-6 w-6 rounded-full"
													/>
													<span className="ml-3 block font-normal truncate">Julien Schiano</span>
												</div>
											</li>
										</ul>
									</div>
								</div>*/}
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-wrap pl-0 md:p-4 md:space-y-4 w-full">{carsComponents}</div>
			</div>
		</main>
	);
};

export const getStaticProps = getStaticPropsNicho(async () => {
	const cms = db<Cooches>();
	const brands = await cms.request(readItems('co_brands', { sort: 'name' }));
	const cars = await cms.request(readItems('co_cars', { sort: 'name' }));

	return {
		props: {
			cars,
			brands,
			title: 'Marcas de coches'
		}
	};
});

export default Dashboard;
